
// ExibirCliente.js 

import React from 'react';
import Box from '@mui/material/Box';
import '../App.css';
 

function ExibirCliente({ cliente, handleCancelaExibe  }) {
  
  // Função para formatar a data no formato "DD-MM-YYYY"
  function formatarData(data) {
    if (!data) {
      return "Data não disponível";
    }
    const partes = data.split('-');
    if (partes.length !== 3) {
      return "Data inválida";
    }
    const dia = partes[2];
    const mes = partes[1];
    const ano = partes[0];
    return `${dia}/${mes}/${ano}`;
  }


// Função para formatar o valor de crédito como moeda brasileira
  const formatarMoeda = (valor) => {
  return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(valor);
  };

  return (

    <div
      style={{
        minHeight: 'calc(100vh - 20px)',
        maxWidth: '900px',
        paddingTop: '10px',
        marginLeft: '0px',
        margin: '0 auto', // Centralizando o container
        textAlign: 'center', // Alinhamento central
      }}
    >

      <div style={{ marginBottom: '20px'}}>
        <h3>Controle de Clientes</h3>
      </div>

      {cliente && (
        <div style={{ textAlign: 'left', marginLeft: '20px' }}>
          <div style={{ display: 'flex', marginBottom: '0px' }}>
            <div style={{ marginRight: '20px', width: '500px' }}>
              <label style={{ display: 'block', width: '500px', marginRight: '20px' }}>Nome:</label>
              <input type="text" value={cliente.nomecli} readOnly style={{ width: '100%', height: '30px' }} />
            </div>
            <div style={{ width: '110px', marginRight: '20px' }}>
              <label style={{ display: 'block', width: '110px', marginRight: '20px' }}>Código:</label>
              <input type="text" value={cliente.codcli} readOnly style={{ width: '110px', height: '30px' }} />
            </div>
            <div style={{ width: '200px' }}>
              <label style={{ display: 'block', width: '200px', marginBottom: '0px' }}>Data de Cadastro:</label>
              <input type="text" value={formatarData(cliente.dtcadastro)} readOnly style={{ width: '200px', height: '28px' }} />
            </div>
          </div>

          <div style={{ display: 'flex', marginBottom: '0px' }}>
          <div style={{ marginRight: '20px', width: '410px' }}>
            <label style={{ display: 'block', width: '410px' }}>E-mail:</label>
            <input type="text" value={cliente.email} readOnly style={{ width: '410px', height: '30px' }} />
           </div>
           <div style={{ width: '200px', marginRight: '20px' }}>
            <label style={{ display: 'block', width: '200px', marginBottom: '0px', marginRight: '20px' }}>Telefone:</label>
            <input type="text" value={cliente.fone} readOnly style={{ width: '200px', height: '28px' }} />
           </div>
           <div style={{ width: '200px' }}>
            <label style={{ display: 'block', width: '200px', marginBottom: '0px' }}>Celular:</label>
            <input type="text" value={cliente.celular} readOnly style={{ width: '200px', height: '28px' }} />
           </div>
          </div>
              
          <div style={{ display: 'flex', marginBottom: '0px' }}>
          <div style={{ width: '200px', marginRight: '20px' }}>
            <label style={{ display: 'block', width: '200px' }}>CNPJ:</label>
            <input type="text" value={cliente.cnpjcli} readOnly style={{ width: '200px', height: '30px' }} />
          </div>
          <div style={{ width: '190px', marginRight: '20px' }}>
            <label style={{ display: 'block', width: '190px', marginRight: '20px'  }}>CPF:</label>
            <input type="text" value={cliente.cpfcli} readOnly style={{ width: '190px', height: '30px' }} />
           </div>
           <div style={{ width: '200px', marginRight: '20px' }}>
            <label style={{ display: 'block', width: '200px', marginBottom: '0px', marginRight: '20px' }}>Incrição Estadual:</label>
            <input type="text" value={cliente.inscricaoest} readOnly style={{ width: '200px', height: '30px' }} />
           </div>
           <div style={{ width: '200px' }}>
            <label style={{ display: 'block', width: '200px', marginBottom: '0px' }}>Incrição Municipal:</label>
            <input type="text" value={cliente.inscricaomun} readOnly style={{ width: '200px', height: '30px' }} />
           </div>
          </div>
         

        <div style={{ display: 'flex', marginBottom: '0px' }}>
          <div style={{ width: '120px', marginRight: '20px' }}>
            <label style={{ display: 'block', width: '120px', marginRight: '20px' }}>CEP:</label>
            <input type="text" value={cliente.cep} readOnly style={{ width: '120px', height: '30px' }} />
          </div>
          <div style={{ width: '420px', marginRight: '20px' }}>
            <label style={{ display: 'block', width: '420px', marginRight: '20px'  }}>Logradouro:</label>
            <input type="text" value={cliente.logradouro} readOnly style={{ width: '420px', height: '30px' }} />
          </div>
          <div style={{ width: '100px', marginRight: '20px' }}>
            <label style={{ display: 'block', width: '100px', marginRight: '20px' }}>Número:</label>
            <input type="text" value={cliente.numero} readOnly style={{ width: '100px', height: '30px' }} />
          </div>
          <div style={{ width: '200px' }}>
            <label style={{ display: 'block', width: '150px' }}>Complemento:</label>
            <input type="text" value={cliente.complemento} readOnly style={{ width: '150px', height: '30px' }} />
          </div>
        </div>       
                  
        <div style={{ display: 'flex', marginBottom: '0px' }}>
            <div style={{ width: '410px', marginRight: '20px' }}>
              <label style={{ display: 'block', width: '410px', marginRight: '20px' }}>Bairro:</label>
              <input type="text" value={cliente.bairro} readOnly style={{ width: '410px', height: '30px' }} />
            </div>
            <div style={{ width: '340px', marginRight: '20px' }}>
              <label style={{ display: 'block', width: '340', marginRight: '20px' }}>Cidade:</label>
              <input type="text" value={cliente.cidade} readOnly style={{ width: '340px', height: '30px' }} />
               </div>
            <div style={{ width: '60px' }}>
              <label style={{ display: 'block', width: '60px' }}>Estado:</label>
              <input type="text" value={cliente.uf} readOnly style={{ width: '60px', height: '30px' }} />
            </div>
         </div>
                  
      <div style={{ display: 'flex', marginBottom: '25px' }}>
        <div style={{ width: '120px', marginRight: '0px', marginBottom: '0px' }}>
          <label style={{ display: 'block', width: '120px', marginBottom: '0px' }}>Crédito:</label>
          <input type="text" value={formatarMoeda(cliente.credito)} readOnly style={{ width: '120px', height: '30px' }} />
        </div>
        <div style={{ width: '270px', marginLeft: '20px', marginBottom: '25px' }}>
          <label style={{ display: 'block', width: '270px' }}>Forma de Pagamento:</label>
          <input type="text" value={cliente.formapag || ''} readOnly style={{ width: '270px', height: '30px' }} />
        </div>
            
        <div style={{ width: '280px', marginLeft: '20px', marginBottom: '25px' }}>
          <label style={{ display: 'block', width: '280px' }}>Condição de Pagamento:</label>
          <input type="text" value={cliente.condpag || ''} readOnly style={{ width: '280px', height: '30px' }} />
        </div>
            
        </div>          
        </div>
      )}
    
    <Box display="flex" justifyContent="center" alignItems="center" mt={0}>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '0px' }}>
        <button type="button" className='btn-menu' onClick={handleCancelaExibe}
          style={{ width: '150px', height: '30px', padding: '0px 0px', color: 'inherit' }}>Fechar  Clientes
        </button>
      </div>
    </Box>

  <br />
      
  </div>

  );
    
}

export default ExibirCliente;